import React from 'react';
import { Navigate } from 'react-router-dom';

export const SuperAdminPrivateRoute: React.FC<{ children: React.ReactElement } > = ({ children }) => {
  const token = localStorage.getItem('sa_token');
  if (!token) {
    return <Navigate to="/super-admin/login" replace />;
  }
  return children;
};

